import * as React from 'react';
import { connect } from 'react-redux';
import { getLoginState } from '../selectors/login';
import { get, post, put } from '../helpers/FetchHelpers';

interface LoginState {
  isAuthenticated: boolean;
  tokenType: string;
  accessToken: string;
}

interface Headers {
  [key: string]: string;
}

interface FetchProps {
  fetchGet: (url: string, abortController?: AbortController) => Promise<any>;
  fetchPost: (
    url: string,
    data: any,
    abortController?: AbortController
  ) => Promise<any>;
  fetchPut: (
    url: string,
    data: any,
    abortController?: AbortController
  ) => Promise<any>;
}

function getHeaders(store: any): Headers {
  const loginState = getLoginState(store) as LoginState;
  console.log('loginState.isAuthenticated', loginState.isAuthenticated);
  if (loginState.isAuthenticated) {
    const header: Headers = {
      Authorization: `${loginState.tokenType} ${loginState.accessToken}`
    };

    return header;
  }

  return {};
}

const storeToState = connect((store: any) => ({
  fetchGet: (url: string, abortController?: AbortController) => {
    const header = getHeaders(store);

    return get(url, undefined, header, abortController?.signal);
  },
  fetchPost: (url: string, data: any) => {
    return post(url, data);
  },
  fetchPut: (url: string, data: any, abortController?: AbortController) => {
    const header = getHeaders(store);

    return put(url, data, header, abortController?.signal);
  }
}));

export default function withAjax() {
  return <P extends object>(
    OriginalComponent: React.ComponentType<P & FetchProps>
  ) => {
    const WithAjax = (props: any) => {
      return <OriginalComponent {...props} />;
    };
    return storeToState(WithAjax);
  };
}
